import { Directive, ElementRef, Input } from '@angular/core';
import { SlIdContext } from './sl-id-context';

@Directive({ selector: '[sl-aria-activedescendant]' })
export class SlAriaActiveDescendantDirective {
  constructor(private el: ElementRef, private ids: SlIdContext) {}

  @Input('sl-aria-activedescendant')
  set localId(value: string) {
    if (!value) {
      this.el.nativeElement.removeAttribute('aria-activedescendant');
      return;
    }
    this.el.nativeElement.setAttribute('aria-activedescendant', this.ids.id(value));
    this.el.nativeElement.removeAttribute('sl-aria-activedescendant');
  }
}
